import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import CompaniesPage from '../views/CompaniesPage.vue'
import LoginPage from '@/views/LoginPage.vue'
import OrderPage from '@/views/OrderPage.vue'
import OrderListByCompany from '@/views/OrderListByCompany.vue'
import DriversPage from '@/views/DriversPage.vue'
import AllOrders from '@/views/AllOrders.vue'
import ProfilPage from '@/views/ProfilPage.vue'
import AllProducts from '@/views/AllProducts.vue'
import AnalyticsPage from '@/views/AnalyticsPage.vue'
import StockPage from '@/views/StockPage.vue'
import LogsPage from '@/views/LogsPage.vue'
import NotFound from '@/views/NotFound.vue'
import PendingDeliveries from '@/views/PendingDeliveries.vue'
import ApprovedDeliveries from '@/views/ApprovedDeliveries.vue'
import LoanPage from '@/views/LoanPage.vue'
import auth from '@/stores/auth'
import DriverBooks from '@/views/DriverBooks.vue'
import CashPage from '@/views/CashPage.vue'

const routes = [
  { path: '/giris', component: LoginPage },
  { path: '/profil', component: ProfilPage, meta: { requiresAuth: true } },
  { path: '/', component: HomePage, meta: { requiresAuth: true } },
  { path: '/tum-siparisler', component: AllOrders, meta: { requiresAuth: true } },
  {
    path: '/onay-bekleyenler',
    name: 'PendingDeliveries',
    component: PendingDeliveries, meta: { requiresAuth: true }
  },
  {
    path: '/teslimatlar',
    component: ApprovedDeliveries, meta: { requiresAuth: true }
  },
  { path: '/bayiler', component: CompaniesPage, meta: { requiresAuth: true } },
  { path: '/siparisler', component: OrderPage, meta: { requiresAuth: true } },
  { path: '/suruculer', component: DriversPage, meta: { requiresAuth: true } },
  { path: '/urunler', component: AllProducts, meta: { requiresAuth: true } },
  { path: '/siparisler/:dealerId', component: OrderListByCompany, meta: { requiresAuth: true } },
  { path: '/cari', component: LoanPage, meta: { requiresAuth: true } },
  {
    path: '/drivers/:driverId/books',
    component: DriverBooks, meta: { requiresAuth: true }
  },
  {
    path: '/kasa', component: CashPage, meta: { requiresAuth: true },
  },
  { path: '/analiz', component: AnalyticsPage, meta: { requiresAuth: true } },
  { path: '/stok', component: StockPage, meta: { requiresAuth: true } },
  { path: '/islemler', component: LogsPage, meta: { requiresAuth: true } },
  { path: '/:catchAll(.*)', component: NotFound, meta: { requiresAuth: true } }

]

const router = createRouter({
  history: createWebHistory(),
  routes
})


router.beforeEach((to, from, next) => {
  const isLoggedIn = !!auth.state.token
  const requiresAuth = to.meta?.requiresAuth === true

  if (requiresAuth && !isLoggedIn) {
    return next('/giris')
  }

  if (to.path === '/giris' && isLoggedIn) {
    return next('/')
  }

  next()
})


export default router
